import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { RetornaDadosRequest } from "../helpers/retorna-dados-request";
@Injectable({
	providedIn: "root"
})
export class PropostaAdiantamentoService {
	constructor(
		private http: HttpClient,
		private retornoStatus: RetornaDadosRequest
	) {}

	getPropostaEventoDeAdiantamento(): Observable<any> {
		return this.http.get<any>(`${environment.urlApi}/Proposta/AdiantamentoDePagamento/GetPropostaEventoDeAdiantamento`);
	}

	getPropostaAdiantamentoObjetoSegurado(idTipoDeProposta, dataContratoOcPedido, all): Observable<any> {
		let params = new HttpParams();
		if (idTipoDeProposta > 0) params = params.append("idTipoDeProposta", idTipoDeProposta);

		if (dataContratoOcPedido) params = params.append("dataContratoOcPedido", dataContratoOcPedido);

		if (all) params = params.append("all", all);

		return this.http.get(
			`${environment.urlApi}/Proposta/AdiantamentoDePagamento/GetPropostaAdiantamentoObjetoSegurado`,
			{ params }
		);
	}

	getPropostaAdiantamentobyCode(codigoProposta: string, completo = true, isDuplicateProposal = false): Observable<any> {
		let params = new HttpParams();
		if (codigoProposta) params = params.append("codigoProposta", codigoProposta);
		params = params.append("completo", completo.toString());
		params = params.append("isDuplicateProposal", isDuplicateProposal.toString());
		return this.http.get<any>(`${environment.urlApi}/Proposta/AdiantamentoDePagamento/GetPropostaAdiantamento`, {
			params
		});
	}

	updateStatus(codigoProposta: string, cdStatus: number) {
		let params = new HttpParams();
		if (codigoProposta) params = params.append("codigoProposta", codigoProposta);

		if (cdStatus > 0) params = params.append("cdStatus", cdStatus.toString());

		return this.http.get<any>(`${environment.urlApi}/Proposta/AdiantamentoPagamento/UpdateStatus`, { params });
	}

	getTipoDePropostaById(id: number): Observable<any> {
		return this.http.get(`${environment.urlApi}/Proposaltype/GetTipoDePropostaById?id=${id}`);
	}
}
